import { render, staticRenderFns } from "./GoogleButton.vue?vue&type=template&id=f80f5660&scoped=true&"
import script from "./GoogleButton.vue?vue&type=script&lang=js&"
export * from "./GoogleButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleButton.vue?vue&type=style&index=0&id=f80f5660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80f5660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
